<template>
    <div id="app">

        <!-- Loading -->
        <b-loading :is-full-page="true" :active.sync="isLoading"/>

        <!-- Login -->
        <AuthPage v-if="!userLogged"/>

        <!-- App -->
        <template v-if="userLogged">

            <!-- Header -->
            <header class="app-header">
                <div class="container">
                    <b-navbar>
                        <template slot="brand">
                            <b-navbar-item tag="router-link" :to="{name: 'home'}">
                                App de Pedidos
                            </b-navbar-item>
                        </template>
                        <template slot="end">
                            <b-navbar-item tag="router-link" :to="{name: 'user.orders'}">
                                <b-icon icon="shopping-cart" size="is-small"/>
                                <div class="link-text">Meus pedidos</div>
                            </b-navbar-item>

                            <template v-if="isAdminUser">
                                <b-navbar-item tag="router-link" :to="{name: 'users'}">
                                    <b-icon icon="users" size="is-small"/>
                                    <div class="link-text">Usuários</div>
                                </b-navbar-item>
                                <b-navbar-item tag="router-link" :to="{name: 'products'}">
                                    <b-icon icon="box" size="is-small"/>
                                    <span class="link-text">Produtos</span>
                                </b-navbar-item>
                                <b-navbar-item tag="router-link" :to="{name: 'orders'}">
                                    <b-icon icon="shopping-cart" size="is-small"/>
                                    <span class="link-text">Pedidos</span>
                                </b-navbar-item>
                                <b-navbar-item tag="router-link" :to="{name: 'orders.reports.products'}">
                                    <b-icon icon="chart-pie" size="is-small"/>
                                    <span class="link-text">Relatório</span>
                                </b-navbar-item>
                                <b-navbar-item tag="router-link" :to="{name: 'conf'}">
                                    <b-icon icon="cog" size="is-small"/>
                                    <span class="link-text">Configurações</span>
                                </b-navbar-item>
                            </template>

                            <b-navbar-dropdown class="user-dropdown" right>
                                <div class="user-name" slot="label">
                                    <b-icon icon="user-circle"/>
                                    <div class="link-text">{{ user.displayName }}</div>
                                </div>

                                <div class="dropdown-item user-info">
                                    <div class="is-size-3">{{ user.displayName }}</div>
                                    <div class="is-small">{{ user.email }}</div>
                                    <userAccountType/>
                                </div>

                                <!--                                <b-navbar-item>Meus Dados</b-navbar-item>-->
                                <b-navbar-item @click="userLogout">Sair</b-navbar-item>
                            </b-navbar-dropdown>
                        </template>
                    </b-navbar>
                </div>
            </header>

            <!-- Content -->
            <main class="app-main">
                <router-view class="app-content"/>
            </main>

            <!-- Footer -->
            <footer class="app-footer">
                <div class="container"><p class="is-small">Orgulhosamente desenvolvido na <a
                    href="https://www.cimsw.com.br" target="_blank">CIM Soluções Web</a></p></div>
            </footer>
        </template>

    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import AuthPage from "@/modules/users/components/AuthPage";
    import userAccountType from "./modules/users/components/userAccountType";

    export default {
        name: "App",
        components: {
            AuthPage,
            userAccountType
        },
        computed: {
            ...mapGetters(['user', 'userLogged', 'isLoading', "isAdminUser"])
        },

        methods: {
            userLogout() {
                this.$router.push({name: 'user.logout'})
            }
        }
    };
</script>